// @flow
import styled from "styled-components"
import StyledLink from "components/StyledLink"

export const ShoppingBasketLinkWrap = styled(StyledLink)`
  margin: 0 2rem;
  font-size: 1.3rem;
  font-weight: ${(props) => props.theme.fontWeights.book};
  color: ${(props) => props.theme.color.primaryText};
  text-transform: uppercase;
`;



// WEBPACK FOOTER //
// ./src/pages/_Page/MainNav/LoggedInNav/DesktopLoggedInNav/ShoppingBasketLink/styled.js